import { render, staticRenderFns } from "./retailers.vue?vue&type=template&id=48896f71"
import script from "./retailers.vue?vue&type=script&lang=js"
export * from "./retailers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports